"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function dateOfBirthRangeValidator(minValue, maxValue) {
    return function (control) {
        // Get the value from the control
        var value = control.value;
        if (value && value !== '') {
            var dateValue = moment(value, constants_1.Constants.DATE_PARSE_FORMAT);
            // Did they exceed the maximum age
            if (!dateValue.startOf('day').isSameOrAfter(minValue.startOf('day'))) {
                return { 'range': value };
            }
            // Did they exceed the maximum age
            if (!dateValue.startOf('day').isSameOrBefore(maxValue.startOf('day'))) {
                return { 'range': value };
            }
        }
        return null;
    };
}
exports.dateOfBirthRangeValidator = dateOfBirthRangeValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/date-of-birth-range.validator.js